export class StudyDocumentModel {

    "studyId": Number;
    "createdDate": String;
    "fileUrl": String;
    "title": String;
    "fileType": String
}
